// helpers/ViewHelpers.js

import { ViewType } from "../Enums"; // Ensure ViewType is imported correctly
import { isSharedWithUser } from "../permissions/Permissions";

// ── Display ordering (shared by ViewsPane, ProjectsChoser, TreeHelpers) ─────
// Type order: submissions → submissions_under_review → reviews → users → anything else
const VIEW_TYPE_ORDER = ["submissions", "submissions_under_review", "reviews", "users"];

export const viewTypeRank = (type) => {
  const i = VIEW_TYPE_ORDER.indexOf(type);
  return i === -1 ? VIEW_TYPE_ORDER.length : i;
};

// Mutually exclusive; also doubles as the display-order rank (mine < shared < system < other)
const CATEGORY_RANK = { mine: 0, shared: 1, system: 2, other: 3 };

export const viewCategory = (view, userId) => {
  if (view?.write === "SYSTEM") return "system";
  if (!!userId && view?.owner === userId) return "mine";
  if (isSharedWithUser({ read: view?.read, userId })) return "shared";
  return "other";
};

// Type → default view first → mine/shared/system → alpha
export const compareViewsForDisplay = (userId) => (a, b) => {
  const typeDiff = viewTypeRank(a.type) - viewTypeRank(b.type);
  if (typeDiff !== 0) return typeDiff;

  const defaultDiff = (b.defaultView ? 1 : 0) - (a.defaultView ? 1 : 0);
  if (defaultDiff !== 0) return defaultDiff;

  const categoryDiff = CATEGORY_RANK[viewCategory(a, userId)] - CATEGORY_RANK[viewCategory(b, userId)];
  if (categoryDiff !== 0) return categoryDiff;

  const labelA = a.viewLabel ?? "";
  const labelB = b.viewLabel ?? "";
  return String(labelA).localeCompare(String(labelB));
};

//ToDo - change the stat wisget into types so we can place them where we like and we are updating hte correct value
//e.g. statwidget[1] may or may not be complete submissions/applications.  We need a type === applications and 
//a label to know waht to display.  For now we can assume order/placement.
/**
 * Updates the statWidget values based on the submissions data and view configuration.
 * @param {Array} submissionsData - Array of submission objects.
 * @param {Object} initialView - The initial view object containing statWidget, token, and other properties.
 * @param {number} usersLength - Number of users to set if view.bUsers is true.
 * @param {number} reviewersLength - Number of reviewers to set if view.bUsers is true.
 * @returns {Object} - The updated view object with modified statWidget.
 */
export const updateStatWidget = (
  initialView,
  totalSubmissions,
  submittedSubmissions,
  inCompleteSubmissions,
  usersLength,
  reviewersLength
) => {
  let updatedStatWidget = initialView.statWidget.map(item => ({ ...item }));

  if (initialView.type !== ViewType.USERS) {
    const completeSubmissions = totalSubmissions - inCompleteSubmissions;

    // Check if each element exists before updating
    if (updatedStatWidget[0]) {
      updatedStatWidget[0].value = totalSubmissions;
    }

    if (updatedStatWidget[1]) {
      updatedStatWidget[1].value = completeSubmissions;
    }

    if (updatedStatWidget[2]) {
      updatedStatWidget[2].value = inCompleteSubmissions;
    }

    if (updatedStatWidget[3]) {
      updatedStatWidget[3].value = submittedSubmissions;
    }
  } else {
    // Check if each element exists before updating for bUsers case
    if (updatedStatWidget[0]) {
      updatedStatWidget[0].value = usersLength;
    }

    if (updatedStatWidget[1]) {
      updatedStatWidget[1].value = reviewersLength;
    }

    if (updatedStatWidget[2]) {
      updatedStatWidget[2].value = 0;
    }
  }

  //console.log("updatedStatWidget: ", updatedStatWidget);

  // Return the updated view object
  return {
    ...initialView,
    statWidget: updatedStatWidget,
  };
};

export const updateViewWithWidget = (selectedView, reviews, submissions, submitters, reviewers) => {
console.log("selectedView.viewLabel", selectedView.viewLabel);
  reviews.forEach((s,i) => {
    if (!s.meta) console.warn(`reviews[${i}] has null meta`, s);
  });
  submissions.forEach((s,i) => {
    if (!s.meta) console.warn(`submissions[${i}] has null meta`, s);
  });
  const isReviewView = selectedView.viewLabel === "Reviews";
  const totalSubmissionsLength = isReviewView ? reviews.length : submissions.length;
  const completedFilteredSubmissionsLength = isReviewView
    ? reviews.filter(submission => submission.meta.percentComplete === 100).length
    : submissions.filter(submission => submission.meta.percentComplete === 100).length;
  const submittedSubmissionsLength = isReviewView
    ? reviews.filter(submission => submission.meta.complete).length
    : submissions.filter(submission => submission.meta.complete).length;
  const inCompleteSubmissionsLength = totalSubmissionsLength - completedFilteredSubmissionsLength;
  //console.log("", );
  //console.log("totalSubmissionsLength", );
  //console.log("completedFilteredSubmissionsLength", completedFilteredSubmissionsLength);
  //console.log("inCompleteSubmissionsLength", inCompleteSubmissionsLength);

  return updateStatWidget(
    selectedView,
    totalSubmissionsLength,
    submittedSubmissionsLength,
    inCompleteSubmissionsLength,
    submitters.length,
    reviewers.length
  );
};
